import i18n from 'scoreboard/components/i18n'

const PrettyBoolean = function(filter, meta) {
	let label = filter.label
	if (!label) {
		label = !!meta.formOptions.choices[0].id == filter.value ? meta.formOptions.choices[0].label : meta.formOptions.choices[1].label
	}
	return i18n.get('report.filter.pretty.numeric.equals',label)
}

export default PrettyBoolean

PrettyBoolean.__filename__ = 'reports/common/filter/pretty-boolean.js'
